export const logCustomEvent = (eventName, values) => {
    if (!window.braze) {
        return;
    }

    window.braze.logCustomEvent(eventName, values);
};

export const setCustomAttributes = (key, value) => {
    if (!window.braze) {
        return;
    }

    window.braze.getUser()?.setCustomUserAttribute(key, value);
};
